"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styleToClassName_1 = require("./styleToClassName");
var extractStyleParts_1 = require("./extractStyleParts");
/**
 * Concatination helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */
function mergeStyles() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a = extractStyleParts_1.extractStyleParts(args), classes = _a.classes, objects = _a.objects;
    if (objects.length) {
        classes.push(styleToClassName_1.styleToClassName(objects));
    }
    return classes.join(' ');
}
exports.mergeStyles = mergeStyles;
//# sourceMappingURL=mergeStyles.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/merge-styles/lib/mergeStyles.js
// module id = ../node_modules/@uifabric/merge-styles/lib/mergeStyles.js
// module chunks = 1